module.exports = __webpack_public_path__ + "img/my-books.b83d9fba.svg";